<template>

  <div class="padded">

    <data-table
      table-ref="tenancy-payments-table"
      title="Payment History"
      :url="'/land/rental/site/' + this.siteId"
      :show-search="false"
      sort-field="date"
      :fields="fields">

      <template #admin-action="props">
          <el-button v-if="isManager('finance')"
            class="hidden-md-and-down"
            type="danger" size="mini" icon="fa fa-trash-alt"
            @click="deletePayment(props.rowData)" circle>
          </el-button>
      </template>

    </data-table>
  </div>

</template>


<script>



import PostMixins from '@/mixins/PostMixins'
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

export default {
  mixins: [PostMixins, DateMixins, NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },
    siteId: {
      type: Number,
      required: true
    }
  },

  methods: {
    deleted () {
      this.$events.emit('tenancy-payments-table-refresh-table')
    },

    deletePayment (row) {
      if (row) {
        this.deleteItem(this, row.id, '/land/rental', 'Land Payment on ' + this.formatDate(row.date) + ' for ' + this.currency + row.total, this.deleted)
      }
    }
  },

  data () {
    return {
      currency: settings.currency,
      localSite: this.rowData,
      taxLabel: settings.taxName,
      fields: [
        {
          name: 'date',
          title: 'Date',
          callback: this.formatDate
        },
        {
          name: 'ref',
          title: 'Ref',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatMoney,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: this.taxLabel,
          callback: this.formatMoney,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          callback: this.formatMoney,
          visible: this.showTax()
        },
        {
          name: '__slot:admin-action',
          visible: this.isSuper()
        }
      ]
    }
  }
}

</script>
